import { Typography, Grid, styled } from "@mui/material";

interface WsSectionTitleWithThinTitleProps {
  title: string;
  subtitle?: string;
  color?: string;
  fontSize?: string;
}

function WsSectionTitleWithThinTitle({
  title,
  subtitle,
  color,
  fontSize = "1.6rem",
}: WsSectionTitleWithThinTitleProps) {
  return (
    <Grid container item xs={12} justifyContent={"center"} spacing={1}>
      <Grid item xs={"auto"}>
        <Title fontSize={fontSize} fontWeight={700} color={color}>
          {title}
        </Title>
      </Grid>
      <Grid item xs={"auto"}>
        <Title fontSize={fontSize} fontWeight={400} color={color}>
          {subtitle}
        </Title>
      </Grid>
    </Grid>
  );
}

export default WsSectionTitleWithThinTitle;

const Title = styled(Typography)`
  font-size: 1.8rem;
  @media screen and (max-width: 768px) {
    font-size: 1.4rem;
  }
`;
